import { html } from '@rxdi/lit-html';

export const Loading = () => html`
  <section class="hero">
    <div class="hero-glow"></div>
    <div class="container">
      <div class="hero-inner">
        <div class="hero-content skeleton-loading">
          <h1 class="hero-title">
            <sl-skeleton
              effect="sheen"
              style="width: 80%; height: 1em; display: inline-block; --border-radius: 6px;"
            ></sl-skeleton
            ><br />
            <sl-skeleton
              effect="sheen"
              style="width: 50%; height: 1em; display: inline-block; --border-radius: 6px;"
            ></sl-skeleton>
          </h1>

          <p class="hero-subtitle" style="margin: 0 0 2.1rem;">
            <sl-skeleton
              effect="sheen"
              style="width: 100%; height: 1em; display: inline-block; --border-radius: 4px;"
            ></sl-skeleton
            ><br />
            <sl-skeleton
              effect="sheen"
              style="width: 100%; height: 1em; display: inline-block; --border-radius: 4px;"
            ></sl-skeleton
            ><br />
            <sl-skeleton
              effect="sheen"
              style="width: 100%; height: 1em; display: inline-block; --border-radius: 4px;"
            ></sl-skeleton
            ><br />
            <sl-skeleton
              effect="sheen"
              style="width: 90%; height: 1em; display: inline-block; --border-radius: 4px;"
            ></sl-skeleton
            ><br />
            <sl-skeleton
              effect="sheen"
              style="width: 40%; height: 1em; display: inline-block; --border-radius: 4px;"
            ></sl-skeleton>
          </p>

          <div class="hero-actions">
            <button class="btn btn-primary btn-lg" style="pointer-events: none;">Разгледайте Продуктите</button>
            <button class="btn btn-secondary btn-lg" style="pointer-events: none;">Запитване</button>
          </div>

          <div class="hero-stats">
            <div class="stat">
              <span class="stat-number">25<span>+</span></span>
              <span class="stat-label">Години опит</span>
            </div>
            <div class="stat">
              <span class="stat-number">500<span>+</span></span>
              <span class="stat-label">Доволни клиенти</span>
            </div>
            <div class="stat">
              <span class="stat-number">1 000<span>+</span></span>
              <span class="stat-label">Машини доставени</span>
            </div>
          </div>
        </div>

        <div class="hero-visual">
          <div class="machine-card">
            <div class="machine-card-header">
              <div class="machine-dot"></div>
              <span class="machine-card-title">
                <sl-skeleton
                  effect="sheen"
                  style="width: 250px; height: 1em; display: inline-block; vertical-align: middle; --border-radius: 4px;"
                ></sl-skeleton>
              </span>
            </div>

            <div class="machine-placeholder" style="background: transparent; padding: 0;">
              <sl-skeleton
                effect="sheen"
                style="width: 100%; height: 350px; display: block; --border-radius: var(--sf-radius-md);"
              ></sl-skeleton>
            </div>

            <p style="color:white; margin: 0 0 1rem 0;">
              <sl-skeleton
                effect="sheen"
                style="width: 85%; height: 1em; display: inline-block; --border-radius: 4px;"
              ></sl-skeleton>
            </p>

            <div class="machine-specs">
              ${[1, 2, 3, 4].map(
                () => html`
                  <div class="spec-pill">
                    <strong>
                      <sl-skeleton
                        effect="sheen"
                        style="width: 70%; height: 1em; display: inline-block; --border-radius: 2px;"
                      ></sl-skeleton>
                    </strong>
                    <sl-skeleton
                      effect="sheen"
                      style="width: 50%; height: 1em; display: inline-block; --border-radius: 2px;"
                    ></sl-skeleton>
                  </div>
                `
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
`;
